var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

    var initializeBlock = function ($block) {

        $(document).on('click', '.block-freecontent-archive__load .btn', function (event) {
            $('.block-freecontent-archive').addClass('is-show');
            $(this).hide();
        })

    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=freecontent-archive', initializeBlock);
    }
})

